import { IntegrationConfig } from './integrationTypes';

export const INTEGRATION_CONTACTS = 'contacts';

export const extractIntegrationConfigurations = (config: IntegrationConfig<string>) =>
  Object.values(config).reduce((acc, { name, defaultValue }) => ({ ...acc, [name]: defaultValue }), {});
